import { render, staticRenderFns } from "./SenWordSettings.vue?vue&type=template&id=13c03d0c&scoped=true&"
import script from "./SenWordSettings.vue?vue&type=script&lang=js&"
export * from "./SenWordSettings.vue?vue&type=script&lang=js&"
import style0 from "./SenWordSettings.vue?vue&type=style&index=0&id=13c03d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c03d0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c03d0c')) {
      api.createRecord('13c03d0c', component.options)
    } else {
      api.reload('13c03d0c', component.options)
    }
    module.hot.accept("./SenWordSettings.vue?vue&type=template&id=13c03d0c&scoped=true&", function () {
      api.rerender('13c03d0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/SenWordSettings.vue"
export default component.exports